/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface StatusTimeline { 
    /**
     * The creation date and time of the cluster
     */
    creationTime?: Date;
    /**
     * The date and time when the cluster was ready to execute steps
     */
    readyTime?: Date;
    /**
     * The date and time when the cluster was terminated
     */
    endTime?: Date;
}
